export const nightingaleCatalog = {
  activeSchools: {
    key: "activeSchools",
    endpoint: "/apps/nightingale/admin-usage-report/v1/active-schools/",
  },
  assignmentsVsPrints: {
    key: "assignmentsVsPrints",
    endpoint: "/apps/nightingale/admin-usage-report/v1/assignments-vs-prints/",
  },
  classroomActivity: {
    key: "classroomActivity",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-activity-reading/",
  },
  classroomActivityCsv: {
    key: "classroomActivityCsv",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-activity-reading-csv/",
  },
  classroomActivityAllContent: {
    key: "classroomActivityAllContent",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-activity-all-content/",
  },
  classroomActivityAllContentCsv: {
    key: "classroomActivityAllContentCsv",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-activity-all-content-csv/",
  },
  classroomPowerWordsEngagement: {
    key: "classroomPowerWordsEngagement",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-power-words-engagement/",
  },
  classroomPowerWordsEngagementCsv: {
    key: "classroomPowerWordsEngagementCsv",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-power-words-engagement-csv/",
  },
  classroomOverview: {
    key: "classroomOverview",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-overview-reading/",
  },
  classroomOverviewAllContent: {
    key: "classroomOverviewAllContent",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-overview-all-content/",
  },
  districtEngagementHighlights: {
    key: "districtEngagementHighlights",
    endpoint: "/apps/nightingale/admin-usage-report/v1/district-highlights/",
  },
  districtEngagementHighlightsCsv: {
    key: "districtEngagementHighlightsCsv",
    endpoint:
      "/apps/nightingale/admin-usage-report/v1/district-highlights-csv/",
  },
  monthlyRubricScores: {
    key: "monthlyRubricScores",
    endpoint: "/apps/nightingale/writing-report/v1/monthly-rubric-scores/",
  },
  newselaWritingCsv: {
    key: "newselaWritingCsv",
    endpoint: "/apps/nightingale/writing-report/v1/newsela-writing-csv/",
  },
  readingSkillsPerformance: {
    key: "readingSkillsPerformance",
    endpoint: "/apps/nightingale/classroom-data-report/v1/skills-performance/",
  },
  readingSkillsPerformanceCsv: {
    key: "readingSkillsPerformanceCsv",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/skills-performance-csv/",
  },
  rubricPerformance: {
    key: "rubricPerformance",
    endpoint: "/apps/nightingale/writing-report/v1/rubric-performance/",
  },
  schoolEngagementHighlights: {
    key: "schoolEngagementHighlights",
    endpoint: "/apps/nightingale/admin-usage-report/v1/school-highlights/",
  },
  schoolEngagementHighlightsCsv: {
    key: "schoolEngagementHighlightsCsv",
    endpoint: "/apps/nightingale/admin-usage-report/v1/school-highlights-csv/",
  },
  schoolUsageData: {
    key: "schoolUsageData",
    endpoint: "/apps/nightingale/admin-usage-report/v1/school-data/",
  },
  schoolUsageDataCsv: {
    key: "schoolUsageDataCsv",
    endpoint: "/apps/nightingale/admin-usage-report/v1/school-data-csv/",
  },
  standardsPerformance: {
    key: "standardsPerformance",
    endpoint: "/apps/nightingale/standards-report/v1/standards-performance/",
  },
  standardsPerformanceCsv: {
    key: "standardsPerformanceCsv",
    endpoint:
      "/apps/nightingale/standards-report/v1/standards-performance-csv/",
  },
  stemClassroomActivity: {
    key: "stemClassroomActivity",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-activity-stem/",
  },
  stemClassroomActivityCsv: {
    key: "stemClassroomActivityCsv",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-activity-stem-csv/",
  },
  stemClassroomOverview: {
    key: "stemClassroomOverview",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/classroom-overview-stem/",
  },
  stemStudentActivity: {
    key: "stemStudentActivity",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/student-activity-stem/",
  },
  stemStudentActivityCsv: {
    key: "stemStudentActivityCsv",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/student-activity-stem-csv/",
  },
  stemStudentOverview: {
    key: "stemStudentOverview",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/student-overview-stem/",
  },
  studentActivity: {
    key: "studentActivity",
    endpoint: "/apps/nightingale/classroom-data-report/v1/student-activity/",
  },
  studentActivityCsv: {
    key: "studentActivityCsv",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/student-activity-csv/",
  },
  studentContentEngagement: {
    key: "studentContentEngagement",
    endpoint:
      "/apps/nightingale/admin-usage-report/v1/student-content-engagement/",
  },
  studentPowerWordsEngagement: {
    key: "studentPowerWordsEngagement",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/student-power-words-engagement/",
  },
  studentPowerWordsEngagementCsv: {
    key: "studentPowerWordsEngagementCsv",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/student-power-words-engagement-csv/",
  },
  studentOverview: {
    key: "studentOverview",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/student-overview-reading/",
  },
  studentOverviewAllContent: {
    key: "studentOverviewAllContent",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/student-overview-all-content/",
  },
  studentOverviewMyProgress: {
    key: "studentOverviewMyProgress",
    endpoint:
      "/apps/nightingale/classroom-data-report/v1/student-overview-my-progress/",
  },
  studentUsage: {
    key: "studentUsage",
    endpoint: "/apps/nightingale/admin-usage-report/v1/student-usage/",
  },
  studentWritingActivity: {
    key: "studentWritingActivity",
    endpoint: "/apps/nightingale/writing-report/v1/student-writing-activity/",
  },
  teacherContentEngagement: {
    key: "teacherContentEngagement",
    endpoint:
      "/apps/nightingale/admin-usage-report/v1/teacher-content-engagement/",
  },
  teacherUsage: {
    key: "teacherUsage",
    endpoint: "/apps/nightingale/admin-usage-report/v1/teacher-usage/",
  },
  teacherUsageData: {
    key: "teacherUsageData",
    endpoint: "/apps/nightingale/admin-usage-report/v1/teacher-data/",
  },
  teacherUsageDataCsv: {
    key: "teacherUsageDataCsv",
    endpoint: "/apps/nightingale/admin-usage-report/v1/teacher-data-csv/",
  },
  topicsPerformance: {
    key: "topicsPerformance",
    endpoint: "/apps/nightingale/standards-report/v1/topics-performance/",
  },
  weeklyHeadersViewed: {
    key: "weeklyHeadersViewed",
    endpoint: "/apps/nightingale/admin-usage-report/v1/weekly-headers-viewed/",
  },
  weeklyHeadersViewedCsv: {
    key: "weeklyHeadersViewedCsv",
    endpoint:
      "/apps/nightingale/admin-usage-report/v1/weekly-headers-viewed-csv/",
  },
  weeklyQuizzesSubmitted: {
    key: "weeklyQuizzesSubmitted",
    endpoint:
      "/apps/nightingale/admin-usage-report/v1/weekly-quizzes-submitted/",
  },
  weeklyQuizzesSubmittedCsv: {
    key: "weeklyQuizzesSubmittedCsv",
    endpoint:
      "/apps/nightingale/admin-usage-report/v1/weekly-quizzes-submitted-csv/",
  },
  writingOverview: {
    key: "writingOverview",
    endpoint: "/apps/nightingale/writing-report/v1/writing-overview/",
  },
} as const;
